import httpClient from '@xver/libs/axios';

import type { ResetPasswordResponse } from './model';

const ENDPOINTS = {
    RESET_PASSWORD: '/v1/registry/reset-password',
};

export function resetPassword(): Promise<ResetPasswordResponse> {
    return httpClient.post(ENDPOINTS.RESET_PASSWORD);
}
